<template>
  <div class="examine">
    <div class="content">
      <div class="top">
        <img class="logo" src="../../assets/img/home-logo.png" alt="logo" />
        <p class="title">FWAlgaeDB</p>
      </div>
      <div class="item">
        <img class="wait" src="../../assets/img/examine.png" alt="" />
        <p>
          Submitted successfully, please wait for the administrator to review!
        </p>
        <p class="detail">
          The audit is expected to be completed within 15 working days. The
          audit results will be notified to you by email. Please wait patiently
        </p>
        <button @click="toHome">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Examine',
  data () {
    return {
      paswInput: '',
      mailInput: ''
    }
  },
  created () {
    this.$store.commit('toTop')
  },
  methods: {
    // logo跳回首页
    toHome () {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="scss" scoped>
.examine {
  box-sizing: border-box;
  min-width: vw(1200);
  .content {
    width: vw(1200);
    margin: vw(18) auto 0;
    .top {
      display: flex;
      align-items: center;
      margin-bottom: vw(78);
      .logo {
        width: vw(186);
        height: vw(43);
        margin-right: vw(39);
      }
      .title {
        font-size: vw(24);
        color: #333333;
      }
    }
    .item {
      text-align: center;
      .wait {
        width: vw(360);
        height: vw(348);
        margin-bottom: vw(75);
      }
      p {
        color: #333333;
        font-size: vw(18);
      }
      .detail {
        color: #999999;
        font-size: vw(14);
        margin-top: vw(22);
        margin-bottom: vw(91);
      }
      button {
        outline: none;
        border: none;
        background: $theme_color;
        border-radius: 4px;
        height: vw(36);
        width: vw(158);
        font-size: vw(16);
        color: #fbf9fa;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enroll/examine.vue